import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { useReport } from "../../context/report";

export function Cortes() {
    const { data } = useReport();

    const formatNumber = rowData => {
        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(rowData.metros);
    }

    return (
        <div>
            <Panel collapsed header="CORTES POR ARTIGO" toggleable>
                <DataTable
                    className="p-m-1"
                    style={{ fontSize: 13 }}
                    value={data.artigos}
                >
                    <Column header="Artigo" field="artigo" sortable />
                    <Column header="(m)" field="metros" body={formatNumber} sortable />
                    <Column header="Trama" field="trama" sortable />
                    <Column header="Urdume" field="urdume" sortable />
                    <Column header="Manual" field="manual" sortable />
                    <Column header="Outros" field="outros" sortable />
                    <Column header="Total Quebras" field="total" sortable />
                    <Column header="Batidas" field="batidas" sortable />
                </DataTable>
            </Panel>
            <Panel collapsed header="TABELA DE CORTES" toggleable>
                <DataTable
                    className="p-m-1"
                    style={{ fontSize: 13 }}
                    value={data.cortes}
                >
                    <Column header="Tear" field="tear" sortable />
                    <Column header="Data" field="dataf" sortable />
                    <Column header="Hora" field="hora" />
                    <Column header="Artigo" field="artigo" />
                    <Column header="Rolada" field="rolada" />
                    <Column header="Rolo" field="rolo" />
                    <Column header="(m)" field="metros" sortable />
                    <Column header="Trama" field="trama" sortable />
                    <Column header="Urdume" field="urdume" sortable />
                    <Column header="Manual" field="manual" sortable />
                    <Column header="Outros" field="outros" sortable />
                    <Column header="Total Quebras" field="total" sortable />
                    <Column header="Batidas" field="batidas" sortable />
                </DataTable>
            </Panel>

            <Panel collapsed header="TROCA DE ARTIGO" toggleable>
                <DataTable
                    className="p-m-1"
                    filterDisplay="row"
                    style={{ fontSize: 13 }}
                    value={data.trocas}
                >
                    <Column header="TEAR" field="tear" sortable filter showFilterMatchModes={false} filterMatchMode="equals" />
                    <Column header="DATA" field="dataf" sortable sortField="data" filter showFilterMatchModes={false} filterMatchMode="contains" />
                    <Column header="ARTIGO QUE SAIU" field="artigo" filter showFilterMatchModes={false} filterMatchMode="equals" />
                    <Column header="ARTIGO QUE ENTROU" field="artigo_entrou" filter showFilterMatchModes={false} filterMatchMode="equals" />
                </DataTable>
            </Panel>
        </div>
    )
}